/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./SortSetting.vue?vue&type=template&id=945b5692&scoped=true&"
import script from "./SortSetting.vue?vue&type=script&lang=js&"
export * from "./SortSetting.vue?vue&type=script&lang=js&"
import style0 from "./SortSetting.vue?vue&type=style&index=0&id=945b5692&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "945b5692",
  null
  
)

export default component.exports